import { useHardwareTagNames } from "./useHardwareTagNames";

export const useHardwareTags = (
  hardwareName: string
): {
  cardClassName: string;
  tagLabel?: string;
  tagClassName?: string;
  tagColor?: string;
} => {
  const { isHardwareTagsEnabled, recommendedHardwareNames, mostDeployedHardwareNames } =
    useHardwareTagNames();
  if (!isHardwareTagsEnabled) return { cardClassName: "" };
  const normalizedHardwareName = hardwareName.toLowerCase();
  if (recommendedHardwareNames.includes(normalizedHardwareName))
    return {
      cardClassName: "border border-[#F5A623] border-2",
      tagLabel: "Recommended",
      tagClassName: "border border-[#F5A623] border-2 bg-[#FFF3E0] text-[#CC6608]",
      tagColor: "bg-[#F5A623]"
    };
  if (mostDeployedHardwareNames.includes(normalizedHardwareName))
    return {
      cardClassName: "border border-[#40BA6F] border-2",
      tagLabel: "Most Deployed",
      tagClassName: "border border-[#40BA6F] border-2 bg-[#E0F7E9] text-[#2D914F]",
      tagColor: "bg-[#40BA6F]"
    };
  return { cardClassName: "" };
};
